import { IArcGisGroup } from "@mctypes/global.types";
import { Alert, Button, Group, Loader, Modal, Select, Stack } from "@mantine/core";
import React, { useState } from "react";
import { apiSlice } from "../../../../apiSlice";
import { setShowSuccessMessageThunk } from "../../../../global/globalSlice";
import { useAppDispatch, useAppSelector } from "../../../../hooks";
import { ToastMessagesEnums } from "../../../../mc-shared/sharedConstants";
import { setProjectArcgisInRedux } from "../../../actions";
import { doConnectArcgisGroupToProject, doGetMulticonsultGroups } from "../../gis/GisAPI";

const ConnectArcgisModal: React.FC<{ toggle: any }> = ({ toggle }) => {
  const dispatch = useAppDispatch();
  const project = useAppSelector((state) => state.adminReducer.project);

  const [arcGisGroups, setArcGisGroups] = React.useState<IArcGisGroup[]>(null);
  const [selectedArcGisGroup, setSelectedArcGisGroup] = useState<IArcGisGroup>(null);
  const [failedWarning, setFailedWarning] = useState<boolean>(false);

  React.useEffect(() => {
    init();
  }, []);

  const init = async () => {
    try {
      const _arcGisGroups = await doGetMulticonsultGroups(project?._id);
      setArcGisGroups(_arcGisGroups);
    } catch (error) {
      setFailedWarning(true);
      console.error(error);
    }
  };

  const connectArcgis = async () => {
    if (selectedArcGisGroup == null) {
      return;
    }

    const arcgis = await doConnectArcgisGroupToProject(project._id, selectedArcGisGroup.id);
    dispatch(setProjectArcgisInRedux(arcgis));
    dispatch(setShowSuccessMessageThunk(ToastMessagesEnums.UPDATED));
    dispatch(apiSlice.util.invalidateTags(["Project"]));
    setTimeout(() => {
      toggle(false);
    }, 50);
  };

  return (
    <Modal opened onClose={() => toggle(false)} title="Koble til Multiconsult Cloud GIS gruppe">
      <Stack>
        {arcGisGroups != null ? (
          <Select
            label="Gruppe"
            placeholder="Velg gruppe"
            searchable
            value={selectedArcGisGroup?.id ?? null}
            data={arcGisGroups.map((group) => ({ value: group.id, label: group.title }))}
            onChange={(groupId) => {
              setSelectedArcGisGroup(arcGisGroups.find((group) => group.id === groupId) ?? null);
            }}
          />
        ) : (
          <Loader size="sm" />
        )}
        <Alert color="blue">Finner du ikke gruppen din? Kontakt support (mcapps@multiconsult.no)</Alert>
        {failedWarning && <Alert color="red">Kunne ikke hente grupper. Kontakt support (mcapps@multiconsult.no)</Alert>}
        <Group justify="flex-end">
          <Button variant="default" onClick={() => toggle(false)}>
            Lukk
          </Button>
          <Button disabled={selectedArcGisGroup == null} color="green" onClick={() => connectArcgis()}>
            Koble til gruppen
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
};

export default ConnectArcgisModal;
